import React from "react";
import { locations } from "../data/siteData";
import "./LocationSwitcher.css";

/**
 * LocationSwitcher — reusable toggle between the two Selectra locations.
 * activeId: currently selected location id
 * onChange: (id) => void
 */
export default function LocationSwitcher({ activeId, onChange }) {
  return (
    <div className="location-switcher" role="tablist" aria-label="Choose a location">
      {locations.map((loc) => (
        <button
          key={loc.id}
          type="button"
          role="tab"
          aria-selected={activeId === loc.id}
          className={`location-switcher__btn ${
            activeId === loc.id ? "location-switcher__btn--active" : ""
          }`}
          onClick={() => onChange(loc.id)}
        >
          <span className="location-switcher__code">{loc.code}</span>
          <span className="location-switcher__city">{loc.city}</span>
        </button>
      ))}
      <span
        className="location-switcher__indicator"
        style={{
          transform: `translateX(${
            locations.findIndex((l) => l.id === activeId) * 100
          }%)`,
        }}
        aria-hidden="true"
      />
    </div>
  );
}
